import { Link } from "react-router-dom";
import { novels } from "@/mocks/novels";

interface RankingListProps {
  activeCategory: string;
}

export default function RankingList({ activeCategory }: RankingListProps) {
  const filteredNovels = activeCategory
    ? novels.filter((n) => n.slug === activeCategory)
    : novels;

  const rankedNovels = [...filteredNovels]
    .sort((a, b) => b.reads - a.reads)
    .slice(0, 10);

  const formatReads = (reads: number) => {
    if (reads >= 10000) return `${(reads / 10000).toFixed(0)}万`;
    return reads.toString();
  };

  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            {activeCategory ? `${activeCategory} · ` : ""}热门排行榜
          </h2>
          <Link
            to={`/category/${activeCategory || "全部"}`}
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {rankedNovels.map((novel, index) => (
            <Link
              key={novel.id}
              to={`/article/${novel.id}`}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
                {index < 3 ? (
                  <span
                    className={`text-lg md:text-xl font-heading font-bold ${
                      index === 0
                        ? "text-accent-500"
                        : index === 1
                          ? "text-secondary-500"
                          : "text-foreground-400"
                    }`}
                  >
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-sm font-medium text-foreground-400">
                    {index + 1}
                  </span>
                )}
              </div>

              <div className="w-12 h-16 md:w-14 md:h-20 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={novel.coverImage}
                  alt={novel.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {novel.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {novel.author} · {novel.category}
                </p>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="flex items-center gap-0.5 text-xs text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                    {novel.rating}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {formatReads(novel.reads)} 阅读
                  </span>
                </div>
              </div>

              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-400 text-lg"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}